import React from "react";
import PropTypes from "prop-types";
import css from "../../css/listing/schools.module.css";
import InfoIcon from "../../static/icons/info.svg";

class Schools extends React.PureComponent {
    state = {
        show: 3,
    };

    changeShow = () => {
        this.setState(
            {
                show: this.state.show === 3 ? 10 : 3,
            },
            () => {
                window.dispatchEvent(new Event("resize"));
            }
        );
    };

    render() {
        const { schools } = this.props;
        const { show } = this.state;

        if (!schools || schools.length <= 0) {
            return (
                <div className={css.schools}>
                    <div>
                        {" "}
                        Sorry, but we don't have schools data for this area.
                    </div>
                </div>
            );
        }

        return (
            <div className={css.schools}>
                <table>
                    <tbody>
                        {schools.map((school, index) => {
                            if (show === 3 && index > 2) {
                                return;
                            }

                            return (
                                <tr key={index}>
                                    <td>
                                        <p className={css.type}>
                                            {school.type
                                                ? school.type.label
                                                : ""}
                                        </p>
                                        <p className={css.name}>
                                            {school.name}
                                        </p>
                                    </td>
                                    <td>{school.distance} miles away</td>
                                    <td>
                                        {school.low_grade_level
                                            ? school.low_grade_level.label
                                            : ""}
                                        {" - "}
                                        {school.high_grade_level
                                            ? school.high_grade_level.label
                                            : ""}
                                    </td>
                                    <td>
                                        <a href="#" className={css.infoIcon}>
                                            <InfoIcon />
                                        </a>
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
                {schools.length > 3 ? (
                    <a onClick={this.changeShow} className={css.showButton}>
                        {show === 3 ? "Show more" : "Hide"}
                    </a>
                ) : (
                    ""
                )}
            </div>
        );
    }
}

Schools.propTypes = {
    schools: PropTypes.array,
};

export default Schools;
